// Константы для идентификаторов ролей и организаций
export const CONSTANTS = {
  LEADER_ORG_ID: 1,
  SALES_MANAGER_ROLE_ID: 3,
  CLAIM_OFFICE_ID: 20,
  CLAIM_LEADER_ROLE_ID: 20,
  DEALER_LEADER_ROLE_ID: 25,
  BRAND_LEADER_ROLE_ID: 32,
  ORGANIZATION_TYPE_HR: 275,
} as const

// Константы для типов задач
export const TASK_TYPES = {
  MONTAGE: 'Сделать монтаж',
  MEASUREMENT: 'Сделать замер',
  DELIVERY: 'Сделать доставку',
} as const
